import { ApolloClient, NormalizedCacheObject } from '@apollo/client/core'

import { EntityWithUpload } from './EntityWithUpload'
import { fetchClubUpload } from './fetch/fetchClubUpload'
import { fetchResourceUpload } from './fetch/fetchResourceUpload'
import { fetchCourseUpload } from './fetch/fetchCourseUpload'
import { fetchEventUpload } from './fetch/fetchEventUpload'
import { fetchHoleUpload } from './fetch/fetchHoleUpload'
import { fetchProfilePictureUpload } from './fetch/fetchProfilePictureUpload'
import { fetchReviewUpload } from './fetch/fetchReviewUpload'
import { UploadDetails } from './UploadDetails'

export function fetchUploadFactory(
  entity: EntityWithUpload
):
  | ((
      file: File,
      client: ApolloClient<NormalizedCacheObject>
    ) => Promise<UploadDetails | false>)
  | undefined {
  if (entity === EntityWithUpload.User) {
    return fetchProfilePictureUpload
  } else if (entity === EntityWithUpload.Club) {
    return fetchClubUpload
  } else if (entity === EntityWithUpload.Event) {
    return fetchEventUpload
  } else if (entity === EntityWithUpload.Course) {
    return fetchCourseUpload
  } else if (entity === EntityWithUpload.Hole) {
    return fetchHoleUpload
  } else if (entity === EntityWithUpload.Resource) {
    return fetchResourceUpload
  } else if (entity === EntityWithUpload.Review) {
    return fetchReviewUpload
  }
}
